import Tr from "./Tr";
import TrServiceProvider from "./TrServiceProvider";

export { Tr, TrServiceProvider };
